<div class="loading" *ngIf="loading">
</div>
<app-loader-spinner></app-loader-spinner>

<circle-progress class="noloading" *ngIf="progressBarLoading" [percent]="progress" [radius]="40" [outerStrokeWidth]="10"
    [innerStrokeWidth]="5" [outerStrokeColor]="'#dc9814'" [innerStrokeColor]="'#ffffff'"
    [animation]="!progressBarLoading" [showSubtitle]="false" [animationDuration]="300">
</circle-progress>

<!-- <progress-bar [progress]="progress" [color]="'#dc9814'" *ngIf="progressBarLoading">
</progress-bar> -->

<router-outlet></router-outlet>